import { Box, FormHelperText, styled, TextFieldProps } from "@mui/material";
import React, { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";

// style more like mui input
const StyledPhoneInput = styled(PhoneInput)({
  ".special-label:has(+.form-control:focus)": {
    color: "#1976d2",
  },
  ".special-label:has(+.invalid-number)": {
    color: "#d32f2f !important",
  },
  ".special-label": {
    left: "9px",
    color: "rgba(0, 0, 0, 0.6)",
    fontSize: "12px",
  },
  ".form-control::placeholder": {
    color: "rgba(0, 0, 0, 0.35) !important",
  },
  ".invalid-number.form-control::placeholder": {
    color: "#d32f2f",
  },
  ".country-list .search": {
    padding: "10px",
  },
  ".country-list .search .search-box": {
    width: "100%",
    marginLeft: 0,
  },
});

interface CustomPhoneInputProps extends Omit<TextFieldProps, "onChange"> {
  value: string;
  onChange: (phone: string) => void;
  label?: string;
  error?: boolean;
  errorMessage?: string;
}

const CustomPhoneInput = forwardRef<HTMLInputElement, CustomPhoneInputProps>(
  ({ value, onChange, label, error, errorMessage, ...props }, ref) => {
    const { i18n } = useTranslation();
    const languageToCountry: Record<string, string> = { ru: "ru", en: "cn" };
    const resolvedCountry =
      languageToCountry[i18n.resolvedLanguage ?? ""] || "ru";

    return (
      <Box>
        <StyledPhoneInput
          country={resolvedCountry}
          value={value}
          onChange={(phone: string) => onChange(phone)}
          specialLabel={label}
          enableSearch={true}
          inputStyle={{
            width: "100%",
          }}
          isValid={!error}
          inputProps={{
            ref,
            ...props,
          }}
          enableLongNumbers
        />

        {error && (
          <FormHelperText error sx={{ marginLeft: 1.5 }}>
            {errorMessage}
          </FormHelperText>
        )}
      </Box>
    );
  }
);

export default CustomPhoneInput;
